export enum AlertAnchorOrigin {
  TOP_LEFT = 'top-left',
  TOP_CENTER = 'top-center',
  TOP_RIGHT = 'top-right',
  BOTTOM_LEFT = 'bottom-left',
  BOTTOM_CENTER = 'bottom-center',
  BOTTOM_RIGHT = 'bottom-right',
}

export function parseAlertAnchorOrigin(origin: string): {
  vertical: 'top' | 'bottom';
  horizontal: 'left' | 'center' | 'right';
} {
  const [vertical, horizontal] = origin.split('-');
  return {
    vertical: vertical as 'top' | 'bottom',
    horizontal: horizontal as 'left' | 'center' | 'right',
  };
}
